import AuthLink from "components/v2/Auth/AuthLink";
import { Link, useLocation } from "react-router-dom";
import { FiArrowLeft, FiLock } from "react-icons/fi";
import { getAuthMode } from "utils/authModal";

const AuthLayout = ({ children }) => {
	const mode = getAuthMode(useLocation());
	return (
		<div className="auth-form w-full">
			{!["login", "register"].includes(mode) && (
				<AuthLink className="auth-back"><FiArrowLeft size={16} aria-hidden="true" /> Back to login</AuthLink>
			)}
			{children}
			{mode === "login" && (
				<p className="auth-switch">Don't have an account? <AuthLink mode="register">Register</AuthLink></p>
			)}
			{mode === "register" && (
				<p className="auth-switch">Already have an account? <AuthLink mode="login">Log in</AuthLink></p>
			)}
			<footer className="auth-footer">
				<span><FiLock size={13} aria-hidden="true" /> Your library, wherever you go.</span>
				<Link to="/privacy-policy" tabIndex={0} target="_blank" rel="noopener noreferrer">Privacy</Link>
			</footer>
		</div>
	);
};

export default AuthLayout;
